import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

import { roundPaymentPerMonth } from '../../../utils/price';
import { loadAgencyPaymentDetails } from '../../../api/applications';
import InputLabel from '../InputLabel/InputLabel';
import { FORM_CONFIG } from '../constants';

import cn from './ApplicationPriceSelector.module.scss';

export const ApplicationPriceSelector = React.memo(
  ({ application, agencyId, agencyNonce, onChange }) => {
    const [paymentPlans, setPaymentPlans] = useState([]);

    const selectedPlan = useMemo(() => {
      return paymentPlans.find(
        (plan) =>
          plan.price ===
          application.form[FORM_CONFIG.member_travel_assurence_plan_price.key],
      );
    }, [application, paymentPlans]);

    const handlePlanChange = (event) => {
      const { value } = event.target;
      onChange({
        [FORM_CONFIG.member_travel_assurence_plan_price.key]: parseInt(value),
        [FORM_CONFIG.member_travel_assurence_plan_months.key]: 1,
      });
    };

    const handleMonthChange = (event) => {
      const { value } = event.target;
      onChange({
        [FORM_CONFIG.member_travel_assurence_plan_months.key]: parseInt(value),
      });
    };

    useEffect(() => {
      const loadPaymentPlans = async () => {
        if (agencyId) {
          const { paymentPlans } = await loadAgencyPaymentDetails({ agencyId });
          setPaymentPlans(paymentPlans);
        }
        if (agencyNonce) {
          const { paymentPlans } = await loadAgencyPaymentDetails({
            agencyNonce,
          });
          const defaultPlan = paymentPlans.filter(
            (plan) => plan.default === true,
          );
          setPaymentPlans(defaultPlan.length ? defaultPlan : [paymentPlans[0]]);
        }
      };
      loadPaymentPlans();
    }, [agencyId, agencyNonce]);

    return (
      <div className={cn.priceSelectorContainer}>
        <div className={cn.radioGroupContainer}>
          <InputLabel
            text="Select price:"
            required={FORM_CONFIG.member_travel_assurence_plan_price.required}
            error={
              application.errors[
                FORM_CONFIG.member_travel_assurence_plan_price.key
              ]
            }
          />
          <RadioGroup
            name={FORM_CONFIG.member_travel_assurence_plan_price.key}
            value={
              application.form[
                FORM_CONFIG.member_travel_assurence_plan_price.key
              ] || null
            }
            onChange={handlePlanChange}
            row
          >
            {paymentPlans.map((paymentPlan) => (
              <FormControlLabel
                key={paymentPlan.price}
                value={paymentPlan.price}
                control={<Radio color="primary" />}
                label={`$${paymentPlan.price}`}
              />
            ))}
          </RadioGroup>
        </div>
        {selectedPlan && (
          <div className={cn.radioGroupContainer}>
            <InputLabel
              text="Please select your payment type:"
              required={
                FORM_CONFIG.member_travel_assurence_plan_months.required
              }
              error={
                application.errors[
                  FORM_CONFIG.member_travel_assurence_plan_months.key
                ]
              }
            />
            <RadioGroup
              name={FORM_CONFIG.member_travel_assurence_plan_months.key}
              value={
                application.form[
                  FORM_CONFIG.member_travel_assurence_plan_months.key
                ]
              }
              onChange={handleMonthChange}
              classes={{
                root: cn.radioGroup,
              }}
              row
            >
              {selectedPlan.options
                .filter((option) => option.enabled)
                .map((option) => (
                  <FormControlLabel
                    key={option.months}
                    value={option.months}
                    control={
                      <Radio color="primary" classes={{ root: cn.radioRoot }} />
                    }
                    label={
                      <div>
                        <div>
                          {option.months === 1
                            ? 'One time'
                            : `${option.months} months`}
                        </div>
                        <div className={cn.optionDetailsLabel}>
                          {`$${roundPaymentPerMonth(
                            selectedPlan.price,
                            option.months,
                          )}${option.months === 1 ? '' : '/month'}, ${option.fee ? `one time $${option.fee} fee` : 'no fee'}`}
                        </div>
                      </div>
                    }
                    classes={{
                      root: classNames(cn.formControlLabelRoot, {
                        [cn.selected]:
                          option.months ===
                          application.form[
                            FORM_CONFIG.member_travel_assurence_plan_months.key
                          ],
                      }),
                      label: cn.formControlLabel,
                    }}
                  />
                ))}
            </RadioGroup>
          </div>
        )}
      </div>
    );
  },
);
